import baseRequest from "./baseReuqest";

export function getBusinessUnitsSmsGatewayAppActivityData() {
    let url = 'api/erp-business-unit-mapping/get-sms-gateway-app-activity-data';
    return baseRequest(url);
}

export function createErpBusinessUnitMapping(data) {
    return baseRequest('api/erp-business-unit-mapping/create', {
        method: 'POST',
        body: data,
    });
}

export function editErpBusinessUnitMapping(id, data) {
    return baseRequest(`api/erp-business-unit-mapping/${id}/edit`, {
        method: 'PUT',
        body: data,
    });
}

export function deleteErpBusinessUnitMapping(id) {
    return baseRequest(`api/erp-business-unit-mapping/${id}/delete`, {
        method: 'DELETE',
    });
}

export function getTransportsForServiceMessage() {
    return baseRequest('api/transport/for-business-unit-mapping');
}
